export const BRAND_STUDIO_ROUTES = Object.freeze({
  home: "/brand-studio",
  create: "/brand-studio/brand-brief",
  references: "/brand-studio/references",
  visualDirection: "/brand-studio/visual-direction",
  newVisualDirection: "/brand-studio/visual-direction/new",
  visualDNA: "/brand-studio/visual-dna",
  logoFamily: "/brand-studio/visual-dna/logo-family",
  logoWorkshop: "/brand-studio/logos",
});

export function brandJourneyDestination(state) {
  if (!state || state === "needs_brand_brief") return BRAND_STUDIO_ROUTES.create;
  if (state === "needs_references") return BRAND_STUDIO_ROUTES.references;
  return BRAND_STUDIO_ROUTES.visualDirection;
}

export function brandJourneyCopy(state) {
  if (!state || state === "needs_brand_brief") {
    return "Начни с рассказа о своём бренде — это станет основой всей визуальной системы.";
  }
  if (state === "needs_references") {
    return "Основа бренда сохранена. Следующий шаг — собрать визуальные ориентиры.";
  }
  if (state === "directions") {
    return "Визуальное направление сохранено. Продолжи работу с выбранной концепцией.";
  }
  return "Основа и референсы готовы. Следующий этап — визуальное направление.";
}
